// Legacy route shim: content is rendered from /section routes.
export default function Page() {
  return null;
}
